function omitPurchaseOrder(checkoutData: Record<string, any>, purchaseOrderOptions: Record<string, any>) {
  const canBeHidden = purchaseOrderOptions?.settings?.canBeHidden

  const needsPurchaseOrder = checkoutData?.checkoutState?.currentOrder?.needsPurchaseOrder

  return canBeHidden && !needsPurchaseOrder
}

export default omitPurchaseOrder
